import { FEEDS } from "@/containers/Content/constants/feeds";
import FeedDetailContainer from "@/containers/Content/FeedDetailContainer";
import { GetStaticPaths, GetStaticProps } from "next";
import React from "react";

export const getStaticPaths: GetStaticPaths = async () => {
  // const skipBuildResult = skipDevBuildInGetStaticPaths() as GetStaticPathsResult;
  // if (skipBuildResult) {
  //   return skipBuildResult;
  // }

  const paths = FEEDS.map((res) => ({
    params: {
      path: res.path,
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const path = params?.path;
  const feed = FEEDS.filter((res) => res.path === path)[0];

  const description = feed.description;

  return {
    props: {
      feed,
      pageDescription: description,
      pageKeywords: feed.keyword,
      pageOgTitle: feed.title + " | 고이 프라임",
      pageOgDescription: description,
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/${feed.imgSrc}.png`,
    },
  };
};

export default function FeedDetail({ feed }: { feed: any }) {
  return <FeedDetailContainer feed={feed} />;
}
